var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationFrontArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 11,
    viewBox: "0 0 5 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.134366 9.65687C0.0914446 9.70458 0.0578902 9.7607 0.0356179 9.82203C0.0133455 9.88335 0.00279126 9.94869 0.00455834 10.0143C0.00632543 10.0799 0.020379 10.1445 0.0459166 10.2044C0.0714541 10.2643 0.107975 10.3184 0.153395 10.3635C0.198816 10.4085 0.252245 10.4438 0.310633 10.4672C0.369021 10.4906 0.431224 10.5017 0.49369 10.4998C0.556157 10.4979 0.617664 10.4832 0.674699 10.4564C0.731735 10.4295 0.783182 10.3912 0.826103 10.3435L4.86996 5.84611C4.95347 5.75333 5 5.63049 5 5.50281C5 5.37513 4.95347 5.25229 4.86996 5.15951L0.826104 0.66165C0.783466 0.612898 0.73203 0.57353 0.674785 0.545834C0.61754 0.518138 0.555626 0.502666 0.49264 0.500315C0.429654 0.497965 0.36685 0.508783 0.307878 0.532142C0.248906 0.555501 0.19494 0.590935 0.149116 0.636386C0.103292 0.681836 0.0665221 0.736398 0.0409429 0.796901C0.0153638 0.857404 0.00148508 0.922642 0.000112793 0.988826C-0.00125949 1.05501 0.00990188 1.12082 0.032949 1.18244C0.0559961 1.24405 0.0904694 1.30024 0.134366 1.34775L3.86994 5.50281L0.134366 9.65687Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationFrontArrow);
export default __webpack_public_path__ + "static/media/pagination_front_arrow.f32a6a482384a38556567030d8edcfbd.svg";
export { ForwardRef as ReactComponent };